import { DateTime } from 'luxon';

export function formatDate(value: string | Date | null, dateOnly: boolean = false): Date | null {
    if (value == null) {
        return null;
    }

    const date = value instanceof Date
        ? DateTime.fromJSDate(value, { zone: 'UTC' })
        : DateTime.fromISO(value, { zone: 'UTC' });

    return dateOnly ? date.minus({ hours: date.hour, minutes: date.minute }).toJSDate() : date.toJSDate();
}

export function formatDateAsString(value: string | Date | null, options: Intl.DateTimeFormatOptions): string | null {
    if (value == null) {
        return null;
    }

    return value instanceof Date
        ? DateTime.fromJSDate(value, { zone: 'UTC' }).toLocal().setLocale('en-gb').toLocaleString(options)
        : DateTime.fromISO(value, { zone: 'UTC' }).toLocal().setLocale('en-gb').toLocaleString(options);
}

export function formatCurrentDate(dateOnly: boolean = false): Date {
    const date = DateTime.utc();
    return dateOnly ? date.minus({ hours: date.hour, minutes: date.minute }).toJSDate() : date.toJSDate();
}

export function compareDate(dateA: string | Date | null, dateB: string | Date | null): boolean {
    if (dateA == null || dateB == null) {
        return false;
    }

    return formatDate(dateA, true)!.toISOString() === formatDate(dateB, true)!.toISOString();
}
